export const EXPLORE_CAMERA_ANGLE = '0.904608 0.351506 -0.241096 27.995464deg';
